<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar right v-model="snackShow" color="white" :timeout="3000">
      <v-icon color="pink" left size="48">mdi-alert</v-icon>
      <v-row class="ml-2">
        <v-col class="py-0" cols="12">
          <span class="title custom-text">{{ snackbar.statusText }}</span>
        </v-col>
        <v-col class="py-0 custom-text" cols="12">{{ snackbar.message }}</v-col>
      </v-row>
    </v-snackbar>
    <v-snackbar right top v-model="snackSuccess" color="white" :timeout="3000">
      <v-row class="ml-2 flex-nowrap">
        <v-icon color="primary" left size="36">mdi-check-circle-outline</v-icon>
        <v-col class="py-0" cols="12">
          <span class="title custom-text">Everything went OK!</span>
        </v-col>
      </v-row>
    </v-snackbar>
    <v-snackbar
      right
      top
      v-model="snackVersion"
      class="hover"
      color="white"
      :timeout="0"
      @click.native="refreshPage"
    >
      <v-row>
        <v-col class="py-0" cols="12">
          <span class="custom-text" style="font-size: 18px">
            There is a new version of the app
            <v-icon class="pb-1" color="#29284c">mdi-emoticon-excited-outline</v-icon>! Click here
            to update.
          </span>
        </v-col>
      </v-row>
    </v-snackbar>
  </v-app>
</template>

<script>
import "./assets/css/style.css";

export default {
  name: "App",
  computed: {
    snackShow: {
      set(value) {
        this.$store.commit("snackShow", value);
      },
      get() {
        return this.$store.getters.snackShow;
      },
    },
    snackSuccess: {
      set(value) {
        this.$store.commit("snackSuccess", value);
      },
      get() {
        return this.$store.getters.snackSuccess;
      },
    },
    snackVersion: {
      set(value) {
        this.$store.commit("snackVersion", value);
      },
      get() {
        return this.$store.getters.snackVersion;
      },
    },
    snackbar() {
      return this.$store.getters.snackbar;
    },
  },
  methods: {
    refreshPage() {
      window.onbeforeunload = null;
      window.location.reload(true);
    },
  },
};
</script>
